import React, { useEffect, useState } from 'react';
import { Shape } from 'Custom-Mindmap';
import Resizer from '../Resizer/resizer';
import NodeInput from '../TextBox/textBox';
import NodeHandels from '../NodeHandel/handels';
import ColorPalette from '../ColorPalette/ColorPalette';
import { outlineOf } from './shapeCatalog';

// Fill of nodes saved before shapes had a colour of their own.
const LEGACY_NODE_COLOR = '#fff';
// How far (px) the hover area reaches past the shape, so the pointer can travel to the "+" buttons.
const HOVER_MARGIN = 34;

const ShapeToNodeType = React.memo(({
    nodeId, data, initialWidth, initialHeight, type, isSelected
}) => {
    const { nodeBg, height, width } = data;
    const [nodeWidth, setNodeWidth] = useState(width || initialWidth);
    const [nodeHeight, setNodeHeight] = useState(height || initialHeight);
    const [isHovered, setIsHovered] = useState(false);

    // Follow the saved size; without one (e.g. a resize was undone) fall back to the type's default size.
    useEffect(() => {
        setNodeWidth(width || initialWidth);
        setNodeHeight(height || initialHeight);
    }, [width, height, initialWidth, initialHeight]);

    const containerStyle = {
        position: 'relative',
        width: nodeWidth,
        height: nodeHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
    const labelStyle = {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };
    const inputContainerStyle = {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '40px',
    };
    return (
        <div
            id={data.id}
            style={containerStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div style={{ position: 'absolute', inset: isHovered ? -HOVER_MARGIN : 0 }} />
            {type !== 'text' && (
                <>
                    <Shape
                        type={type}
                        width={nodeWidth}
                        height={nodeHeight}
                        color={nodeBg || LEGACY_NODE_COLOR}
                        {...outlineOf(data)}
                    />
                    <ColorPalette nodeId={nodeId} data={data} type={type} />
                </>
            )}
            <Resizer
                width={nodeWidth}
                height={nodeHeight}
                setWidth={setNodeWidth}
                setHeight={setNodeHeight}
                isSelected={isSelected}
            />
            <div style={labelStyle}>
                <div style={inputContainerStyle}>
                    <NodeInput data={data} />
                </div>
            </div>
            {type !== 'text' && (<NodeHandels id={data.id} nodeType={type} isHovered={isHovered} />)}
        </div>
    );
});

export default ShapeToNodeType;
